export default function getLandlordUrlFromId(landlordId: number): string {
  return `/landlords/${landlordId}`;
}
